import React from "react";
import moment from "moment";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  InputNumber,
  Button,
  Select,
  DatePicker,
  Row,
  Col,
  Upload,
} from "antd";
import get from "lodash/get";
import { connect } from "react-redux";
import ReactQuill from 'react-quill';
import placeholderImage from '../../assets/img/image_placeholder.jpg';


import {
  updateNewsletterRequest,
  createNewsletterRequest,
  uploadNewsletterImage,
} from "../../api/requests";
import {
  getNewsletterCreatePermission,
  getNewsletterUpdatePermission, getUserShortTimezone,
} from "../../reducers/user/selectors";

import classes from "./NewsletterForm.css";
import { logout } from "../../reducers/user/actions";
import TextArea from "antd/lib/input/TextArea";

const { Option } = Select;

class NewsletterForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      html: props.form.getFieldValue('text'),
      htmlVisible: false,
    };

    this.quillRef = React.createRef();
  }

  componentDidMount() {
    this.setState({
      html: this.props.form.getFieldValue('text'),
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        await this.submit(values);
      }
    });
  };

  submit = async (values, isSend) => {
    try {
      const document = { ...values };
      document.name = get(document, "document_file.fileList", []).slice(
        -1
      ).name;
      document.category = "per_site";
      document.document_file = values.document_file.file;

      const formData = new FormData();

      if (values.document_file && values.document_file.file) {
        formData.append("document_file", values.document_file.file);
      }
      formData.append("send_at", values.send_at.format('YYYY-MM-DD HH:mm'));
      if (values.ends) {
        formData.append("ends", values.ends);
      }
      if (values.ends === 'on_date') {
        formData.append("ends_date", values.ends_date.format('YYYY-MM-DD'));
      }
      if (values.ends === 'after_occurrences') {
        formData.append("ends_occurrences", values.ends_occurrences);
      }
      if (isSend) {
        formData.append("is_scheduled", 'true');
      }
      formData.append("subject", values.subject);
      formData.append("repeat", values.repeat);
      formData.append("text", values.text);
      formData.append("site_ids", `[${values.site_ids}]`);
      formData.append("user_roles_ids", `[${values.user_roles_ids}]`);
      formData.append("time_zone", values.time_zone);

      if (this.props.id) {
        await updateNewsletterRequest(this.props.id, formData);
      } else {
        await createNewsletterRequest(formData);
      }

      this.setState({
        isLoading: false,
        requestResult: { type: "success", message: "Success" },
      });

      setTimeout(() => {
        this.props.onSubmit(this.props.id);
      }, 1000);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        isLoading: false,
        requestResult: {
          type: "error",
          message: get(e, "response.data.message", "Error"),
        },
      });

      if (get(e, "response.data.errors")) {
        const errors = {};
        Object.keys(get(e, "response.data.errors")).forEach(
          (errorFieldKey) => {
            errors[errorFieldKey] = {
              value: values[errorFieldKey],
              errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                (errorMessage) => new Error(errorMessage)
              ),
            };
          }
        );
        this.props.form.setFields(errors);
      }
    }
  };

  onSend = () => {
    this.submit(this.props.form.getFieldsValue(), true);
  };

  onCategoryChange = () => {
    this.props.form.setFieldsValue({ type: null });
  };

  imageHandler = () => {
    const input = document.createElement('input');

    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async () => {
        const file = input.files[0];
        const formData = new FormData();

        formData.append('document_file', file);

        // Save current cursor state
        const range = this.quillRef.current.editor.getSelection(true);

        // Insert temporary loading placeholder image
        this.quillRef.current.editor.insertEmbed(range.index, 'image', placeholderImage);

        // Move cursor to right side of image (easier to continue typing)
        this.quillRef.current.editor.setSelection(range.index + 1);

        const {data: {url}} = await uploadNewsletterImage(formData)

        // Remove placeholder image
        this.quillRef.current.editor.deleteText(range.index, 1);

        // Insert uploaded image
        // this.quillRef.current.editor.insertEmbed(range.index, 'image', res.body.image);
        this.quillRef.current.editor.insertEmbed(range.index, 'image', url);
    };
  }

  quillModules = {
    toolbar: {
      container: [
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['color', 'background'],
            ['link', 'image'],
            ['clean']
        ],
      handlers: {
        image: this.imageHandler,
        color: () => this.colorHandler('color-picker', 'ql-color', 'color', '-3rem'),
        background: () => this.colorHandler('background-picker', 'ql-background', 'background', '-1.5rem')
      }
    },
  }

  colorHandler = (id, toolbarClass, type, margin) => {
    let picker = document.getElementById(id);
    const pickerButton = document.getElementsByClassName(toolbarClass)[0];
    if (!picker) {
      picker = document.createElement('input');
      picker.id = id;
      picker.type = 'color';
      // picker.style.display = 'none';
      picker.style.position = 'absolute';
      picker.style.width = '1rem';
      picker.style.marginLeft = margin;
      picker.style.opacity = 0;
      picker.value = '#FF0000';
      pickerButton.parentElement.appendChild(picker);

      picker.addEventListener('change', (e) => {
        this.quillRef.current.editor.format(type, picker.value);
      }, false);
    }
    setTimeout(() => {
      picker.click();
    });
  }

  render() {
    const { isLoading, requestResult } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const {
      roles,
      newsletterUpdatePermission,
      newsletterCreatePermission,
      id,
      isNew,
      send_at,
      ends_date,
      sites,
    } = this.props;

    const isEditable = id ? newsletterUpdatePermission : newsletterCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.subject}{" "}
                <Badge count="Edit" style={{ backgroundColor: "#2968AE" }} />
              </span>
            ) : isNew ? (
              "Add New Newsletter"
            ) : (
              ""
            )}
          </h4>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <Form.Item>
                  {getFieldDecorator("document_file", {
                    initialValue: get(this.props, "document_file", ""),
                  })(
                    <Upload
                      disabled={!isEditable}
                      accept=".doc,.docx,.odt,.txt,.xls,.xlsx,.ppt,.pptx,.pdf,.png,.jpg,.jpeg,.gif,.mp4"
                      action=""
                      beforeUpload={() => false}
                      multiple={false}
                      fileList={get(
                        this.props.form.getFieldValue("document_file"),
                        "fileList",
                        []
                      ).slice(-1)}
                    >
                      <Button>
                        <Icon type="upload" />
                        {!this.props.form.getFieldValue("document_file") &&
                        this.props.attachment_url
                          ? "Change file"
                          : "Attach a document"}
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col span={12}>
              {!this.props.form.getFieldValue("document_file") &&
              this.props.attachment_url && (
                <div>
                  <a href={this.props.attachment_url} target="_blank">
                    {this.props.attachment_name}
                  </a>
                  <br />
                  <br />
                </div>
              )}
            </Col>
          </Row>


          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Subject</b>
                <Form.Item>
                  {getFieldDecorator("subject", {
                    rules: [{ required: true, message: "Required" }],
                    initialValue: get(this.props, "subject"),
                  })(<Input disabled={!isEditable} type="text" />)}
                </Form.Item>
              </label>
            </Col>

            <Col span={12}>
              <label>
                <b>Select roles:</b>
                <Form.Item>
                  {getFieldDecorator('user_roles_ids', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'user_roles_ids', [])
                  })(
                    <Select mode="multiple">
                      {roles.map(({ id, name }) => <Option key={id} value={id}>{name}</Option>)}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col span={12}>
              <label>
                <b>Select Sites:</b>
                <Form.Item>
                  {getFieldDecorator('site_ids', {
                    initialValue: get(this.props, 'site_ids', [])
                  })(
                    <Select mode="multiple">
                      {sites.map(({ id, name, code }) => <Option key={id} value={id}>{code} - {name}</Option>)}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Send time</b>
                <Form.Item>
                  <div style={{ display: 'flex', alignItems: 'center', maxWidth: '400px' }}>
                    <div>
                      {getFieldDecorator('send_at', {
                        rules: [{
                          required: true,
                        }],
                        initialValue: send_at ? moment(send_at) : null
                      })(
                        <DatePicker
                          showTime
                          id="send_at"
                          name="send_at"
                          allowClear
                        />
                      )}
                    </div>
                  </div>
                </Form.Item>
              </label>
            </Col>

            <Col span={12}>
              <label>
                <b>Time Zone:</b>
                <Form.Item>
                  {getFieldDecorator('time_zone', {
                    initialValue: get(this.props, 'time_zone', 'UTC')
                  })(
                    <Select placeholder='Select'>
                      <Option value="UTC">None (UTC)</Option>
                      <Option value="America/Edmonton">America/Edmonton</Option>
                      <Option value="America/Vancouver">America/Vancouver</Option>
                      <Option value="America/Winnipeg">America/Winnipeg</Option>
                      <Option value="America/Toronto">America/Toronto</Option>
                      <Option value="America/Halifax">America/Halifax</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            {getFieldValue('ends') === 'after_occurrences' &&  <Col span={12}>
              <label>
                <b>Occurrences</b>
                <Form.Item>
                  {getFieldDecorator('ends_occurrences', {
                    initialValue: get(this.props, 'ends_occurrences')
                  })(
                    <InputNumber />
                  )}
                </Form.Item>
              </label>
            </Col>}
          </Row>

          <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Repeat:</b>
                <Form.Item>
                  {getFieldDecorator('repeat', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'repeat', null)
                  })(
                    <Select>
                      <Option value='none'>Does not repeat</Option>
                      <Option value='daily'>Daily</Option>
                      <Option value='weekly'>Weekly</Option>
                      <Option value='monthly'>Monthly</Option>
                      <Option value='annually'>Annually</Option>
                      <Option value='week_day'>Every week day (Monday to Friday)</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {(getFieldValue('repeat') && getFieldValue('repeat') !== 'none') && <Row gutter={12}>
            <Col span={12}>
              <label>
                <b>Ends</b>
                <Form.Item>
                  {getFieldDecorator('ends', {
                    initialValue: get(this.props, 'ends')
                  })(
                    <Select>
                      <Option value='never'>Never</Option>
                      <Option value='on_date'>On date</Option>
                      <Option value='after_occurrences'>After occurrences</Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            {getFieldValue('ends') === 'on_date' &&  <Col span={12}>
              <label>
                <b>End date</b>
                <Form.Item>
                  <div style={{ display: 'flex', alignItems: 'center', maxWidth: '400px' }}>
                    <div>
                      {getFieldDecorator('ends_date', {
                        rules: [{
                          required: true,
                        }],
                        initialValue: ends_date ? moment(ends_date) : null
                      })(
                        <DatePicker
                          id="ends_date"
                          name="ends_date"
                          allowClear
                        />
                      )}
                    </div>
                  </div>
                </Form.Item>
              </label>
            </Col>}
          </Row>}

          <Row gutter={12}>
            <Col>
              <div>
                <span style={{display: 'flex', justifyContent: 'space-between',}}>
                  <b>Text</b>
                  <Button style={{marginTop: '-0.5rem'}} size="small" type="button" onClick={() => {
                    this.setState(state => ({
                      htmlVisible: !state.htmlVisible,
                    }));
                  }}>{this.state.htmlVisible ? 'Hide' : 'Edit'} HTML</Button>
                </span>

                <Form.Item>
                  {getFieldDecorator('text', {
                    rules: [{ required: true, message: 'Required' }],
                    initialValue: get(this.props, 'text', ''),
                  })(
                    <ReactQuill ref={this.quillRef} disabled={!isEditable} theme="snow" onBlur={(range, source, editor) => this.setState({html: editor.getHTML()})}
                      modules={this.quillModules} />
                  )}
                </Form.Item>
              </div>
            </Col>
          </Row>

          { this.state.htmlVisible &&
            <Row gutter={12} style={{marginBottom: '1rem'}}>
              <Col>
                  <label>
                    <b>HTML</b>
                    <TextArea
                      rows={8}
                      value={this.state.html}
                      onChange={e => this.setState({html: e.target.value})}
                      onFocus={e => this.quillRef.current.editor.disable()}
                      onBlur={e => {
                        this.quillRef.current.editor.clipboard.dangerouslyPasteHTML(e.target.value)
                        this.quillRef.current.editor.enable();
                      }} />
                  </label>
                </Col>
            </Row>
          }

          {/* <Row gutter={12} style={{marginBottom: '1rem'}}>
            <Col>
              <label>
                <b>HTML Preview</b>
                <TextArea value={this.props.form.getFieldValue('text')} readOnly/>
              </label>
            </Col>
          </Row> */}

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                >
                  Save
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="button"
                  onClick={this.onSend}
                  className={classes.submitButton}
                >
                  Send
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
            >
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  userShortTimezone: getUserShortTimezone(state),
  newsletterCreatePermission: getNewsletterCreatePermission(state),
  newsletterUpdatePermission: getNewsletterUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "user" })(
  connect(mapStateToProps, mapDispatchToProps)(NewsletterForm)
);



// WEBPACK FOOTER //
// ./src/components/NewsletterForm/NewsletterForm.js